<template>
  <Authenticated>
    <Confirm :open="showAddModifier" message="What is the new modifier set name?" :isCreateConfirm="true" @close="showAddModifier = false" @confirm-modal="create" />

    <div>
      <button @click="showAddModifier = !showAddModifier" class="action-buttons action-colour"><font-awesome-icon icon="plus" /> Add Modifier Set</button>
      <div class="actions">
        <h2>Modifier Sets</h2>
      </div>

      <ul class="table wrapper layout content-gap">
        <router-link :to="'/modifiers/' + currentSet.value._id.replace(/^.*:/, '')" v-bind:key="currentSet" v-for="currentSet in modifier_sets" class="modifierBox">
          <li>
            <div class="box">
              <p>
                <span class="modifier-name">{{ currentSet.value.name }}</span>
                <span v-if="currentSet.value.modifiers && currentSet.value.modifiers.length > 0" class="modifier-price">{{ currentSet.value.modifiers.length }} modifiers</span>
                <span class="tag" v-if="typeof currentSet.value.rules === 'object' && currentSet.value.rules.required"> Required </span>
              </p>
              <!-- undefined is not an object (evaluating 'modifierset_in_product.find') -->
              <span>({{ modifierset_in_product.find((prodmod) => prodmod.mod == currentSet.id).products.length }} products use)</span>
            </div>
          </li>
        </router-link>
      </ul>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { Confirm } from "@monolith/components";
import { mapGetters } from "vuex";
import Slug from "slug";

export default {
  name: "Modifiers",
  components: {
    Authenticated,
    Confirm,
  },
  data() {
    return {
      currentSet: null,
      currentModifier: null,
      currentDrag: null,
      currentDragOverCategory: null,
      showAddModifier: false,
      tableMode: false,
    };
  },
  async mounted() {
    this.$store.commit("currPage", "modifiers");
  },
  methods: {
    create(ms) {
      this.channel.push("document:new", {
        _id: "modifierset:" + Slug(ms),
        name: ms,
        modifiers: [],
        rules: { inventory: false, oneonly: false, required: false },
      });
      this.$store.dispatch("getModifierSets");
    },
    go(id) {
      this.$router.push("/modifiers/" + id.replace(/^.*:/, ""));
    },
    hasModifiers(currentSet) {
      return currentSet.value && currentSet.value.modifiers && currentSet.value.modifiers.length;
    },
  },

  computed: {
    ...mapGetters({
      modifier_sets: "modifier_sets",
      modifierset_in_product: "modifierset_in_product",
    }),
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// .toggle{
//   margin-left: 0;
// }
</style>
